import { render } from "./opted-out-provider-preview.vue?vue&type=template&id=0aa7b0b0&scoped=true"
import script from "./opted-out-provider-preview.vue?vue&type=script&lang=js"
export * from "./opted-out-provider-preview.vue?vue&type=script&lang=js"

import "./opted-out-provider-preview.vue?vue&type=style&index=0&id=0aa7b0b0&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa7b0b0"]])

export default __exports__